import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleHeader(event) {
    event.preventDefault()
    const clickedColumn = event.currentTarget.dataset.column
    const currentSort = new URL(window.location).searchParams.get("sort") || "created_at"
    const currentOrder = new URL(window.location).searchParams.get("order") || "desc"

    const newOrder = (clickedColumn === currentSort && currentOrder === "desc") ? "asc" : "desc"

    const url = new URL(window.location)
    url.searchParams.set("sort", clickedColumn)
    url.searchParams.set("order", newOrder)
    Turbo.visit(url)
  }
  selectSort(event) {
    const selectedColumn = event.target.value
    const url = new URL(window.location)
    url.searchParams.set("sort", selectedColumn)
    Turbo.visit(url)
  }

  toggleOrder(event){
    event.preventDefault()
    const currentOrder = new URL(window.location).searchParams.get("order") || "desc"
    const newOrder = (currentOrder === "asc") ? "desc" : "asc"
    const url = new URL(window.location)
    url.searchParams.set("order", newOrder)
    Turbo.visit(url)
  }
}
